import React from "react";
import ReactDOM from "react-dom/client";
import App from "./common/template/App";
import reportWebVitals from "./reportWebVitals";
import webVitalsToUmami from "./webVitalsToUmami";
import { StyledEngineProvider } from "@mui/material/styles";
import { store } from "./common/state/store";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { installAuthHeaderFallback } from "./common/util/auth";
import { installPerfProbe, onRenderProfile } from "./perfProbe";
import { installChunkReload } from "./chunkReload";
import "./index.css";

installAuthHeaderFallback();

installPerfProbe();
installChunkReload();

/* 
In the case of any 404 or 403 error, S3 will rewrite the url with a #!/ prefix (see 'S3 Static website hosting' config)
Here, we replace those urls back to human-friendly format (without #!/)

reference: https://viastudio.com/hosting-a-reactjs-app-with-routing-on-aws-s3/
relevant sof: https://stackoverflow.com/questions/51218979/react-router-doesnt-work-in-aws-s3-bucket
*/
const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
const history = createBrowserHistory();
if (path) {
  history.replace(path);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const appTree = import.meta.env.DEV ? (
  <React.Profiler id="app" onRender={onRenderProfile}>
    <App />
  </React.Profiler>
) : (
  <App />
);
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <Provider store={store}>{appTree}</Provider>
    </StyledEngineProvider>
  </React.StrictMode>,
);

reportWebVitals(webVitalsToUmami);
